function getSelectedVariant(option1, option2, option3) {
  const optionsSelected = [option1, option2, option3]
    .filter(Boolean)
    .map(handleize)

  return window.limely.product.variants.find(
    (variant) =>
      JSON.stringify(variant.options.map(handleize)) ===
      JSON.stringify(optionsSelected)
  )
}

function setSoldoutOptions(selectedVariant) {
  document
    .querySelectorAll('[data-option-2], [data-option-3]')
    .forEach((element) => {
      element.classList.remove('available')
    })

  window.limely.product.variants.forEach((variant) => {
    if (
      variant.options[0] === selectedVariant.options[0] &&
      variant.available
    ) {
      document
        .querySelector(`[data-option-2="${variant.options[1]}"]`)
        ?.classList.add('available')

      if (variant.options[1] === selectedVariant.options[1]) {
        document
          .querySelector(`[data-option-3="${variant.options[2]}"]`)
          ?.classList.add('available')
      }
    }
  })
}

//when a selected variant is sold out, the add to basket button is disabled
function toggleAddToBasketButton(productAvailable) {
  const addToBasketElement = document.getElementById('add-to-basket')
  if (addToBasketElement) {
    if (!productAvailable) {
      addToBasketElement.classList.add('disabled')
    } else {
      addToBasketElement.classList.remove('disabled')
    }
  }
}

//when clicking a finish variant swatch, update the product carousel to show this image
function setProductCarouselToSelectedVariant(image) {
  if (image) {
    if (!window.limely.hasOnlyDefaultVariant) {
      const variantImageThumbnail = document.getElementById(
        `image-id-${image.id}`
      )

      if (variantImageThumbnail) {
        const indexToSlideTo = [
          ...variantImageThumbnail.parentNode.children
        ].indexOf(variantImageThumbnail)

        window.limely.productCarousel.instance.slideTo(indexToSlideTo)
      }
    }
  }
}

//when clicking an option, update the label to show the name of the selected item
function updateOptionLabels(option1, option2, option3) {
  const selectionOption1 = document.getElementById(`selected-option-1`)
  const selectionOption2 = document.getElementById(`selected-option-2`)
  const selectionOption3 = document.getElementById(`selected-option-3`)

  if (selectionOption1) {
    selectionOption1.innerHTML = option1?.toUpperCase()
  }

  if (selectionOption2) {
    selectionOption2.innerHTML = option2?.toUpperCase()
  }

  if (selectionOption3) {
    selectionOption3.innerHTML = option3?.toUpperCase()
  }
}

//update variant id in the url, required for sharing the url and update the variant id field - used for adding the correct variant to the basket
function updateVariantId(id) {
  window.history.replaceState({}, '', `?variant=${id}`)
  document.getElementById('variantid').value = id //note: when removing the hidden attribute, the value can be seen to update in the rendered input, for some reason it doesn't update in the devtools html viewer
}

//show correct variant price
function updatePrice(id) {
  document
    .querySelectorAll(`.product .sub-total .variant-price`)
    .forEach((item) => {
      item?.classList.remove('active')
    })

  document
    .querySelector(`.product .sub-total #variant-price-${id}`)
    ?.classList.add('active')
}

const productForm = document.querySelector(
  'section.product form[action="/cart/add"]'
)

//on initial page load, toggle variant availability styling
if (productForm) {
  setSoldoutOptions(window.limely.selectedOrFirstAvailableVariant)
  toggleAddToBasketButton(
    window.limely.selectedOrFirstAvailableVariant.available
  )

  productForm.addEventListener('change', function () {
    const formData = new FormData(this)
    const formValues = Object.fromEntries(formData)
    const { option1, option2, option3 } = formValues

    let selectedVariant
    if (!window.limely.hasOnlyDefaultVariant) {
      selectedVariant = getSelectedVariant(option1, option2, option3)
      setSoldoutOptions(selectedVariant)
      updateOptionLabels(option1, option2, option3)
      updateVariantId(selectedVariant.id)
      updatePrice(selectedVariant.id)
      setProductCarouselToSelectedVariant(selectedVariant.featured_image)
      toggleAddToBasketButton(selectedVariant.available)
    } else {
      selectedVariant = window.limely.product
      toggleAddToBasketButton(selectedVariant.available)
    }
  })
}

//equivalent of shopify's handleize function
function handleize(string) {
  return string
    ?.toLowerCase() //Convert the string to lowercase
    .replace(/\./g, '-') //Replace dots with dashes
    .replace(/\s+/g, '-') //Replace spaces with dashes
    .replace(/[^\w\-]+/g, '') //Remove all non-word characters (except for dashes)
    .replace(/\-\-+/g, '-') //Replace multiple dashes with a single dash
    .replace(/^-+|-+$/g, '') //Trim dashes from the beginning and end of the string
}
